<ng-container *ngIf="user$ | async as user">
  <ng-container *ngIf="!loopOptions?.compact; else compactTemplate">
    <div class="row">
      <div class="row col col-xs-10">
        <div class="row filter-row">
          <mat-icon>filter_list</mat-icon>
          <div class="filters">
            <ng-container *ngFor="let filterItem of filterItems">
              <sales-common-loop-filter-chip
                *ngIf="
                  !filterItem.displayName$ ||
                  (filterItem.displayName$ | async) !== null ||
                  (filterItem.displayName$ | async) !== ''
                "
                [filterItem]="filterItem"
                [hideDelete]="filterItem.filterId === 'date-range-filter'"
                (clicked)="selectFilterItem($event)"
                (remove)="removeFilterItem($event)"
              ></sales-common-loop-filter-chip>
            </ng-container>
            <button
              *ngIf="this.hasFilters$ | async"
              mat-button
              class="filter-button"
              color="primary"
              [matMenuTriggerFor]="filterSelection"
            >
              + {{ 'FRONTEND.LOOP.FILTER' | translate }}
            </button>
            <uikit-saved-filters-menu
              [options]="savedFilters$"
              (selection)="selectFilter($event)"
              (saveCurrentFilter)="saveCurrentFilter($event)"
              (removeSavedFilter)="removeSavedFilter($event)"
            ></uikit-saved-filters-menu>
          </div>

          <mat-menu [overlapTrigger]="false" #filterSelection="matMenu">
            <button mat-menu-item *ngIf="!this.loopOptions?.forcedFilters?.marketIds" (click)="openMarketDialog()">
              {{ 'FRONTEND.LOOP.MARKET' | translate }}...
            </button>
            <button mat-menu-item *ngIf="!this.loopOptions?.forcedFilters?.userId" (click)="openSalespeopleDialog()">
              {{ 'FRONTEND.LOOP.FILTERS.SALESPEOPLE' | translate }}...
            </button>
            <button
              mat-menu-item
              *ngIf="!this.loopOptions?.forcedFilters?.userId && !this.loopOptions?.forcedFilters?.marketIds"
              (click)="openDigitalAgentsDialog()"
            >
              {{ 'FRONTEND.LOOP.FILTERS.TASK_MANAGER_USERS' | translate }}...
            </button>
            <button mat-menu-item *ngIf="!this.loopOptions?.forcedFilters?.userId" (click)="openSalesTeamDialog()">
              {{ 'FRONTEND.LOOP.FILTERS.SALES_TEAM' | translate }}...
            </button>
            <ng-container *ngIf="this.resourceFilters$ | async as resourceFilters">
              <ng-container *ngFor="let resourceFilter of resourceFilters">
                <button mat-menu-item (click)="openResourceFilterDialog(resourceFilter.id)">
                  {{ resourceFilter.title | translate }}...
                </button>
              </ng-container>
            </ng-container>
          </mat-menu>
        </div>
      </div>
    </div>
    <div class="main-container row">
      <div class="channel-container row col col-lg-2 col-xs-12">
        @if (channelOptions$ | async; as channels) {
          <!-- Do not show channel selector if only one channel (plus the ALL CHANNELS option)-->
          @if (channels.length > 2) {
            @if (currentChannel$ | async; as currentChannel) {
              <div class="channel-selector-container">
                <button mat-button [matMenuTriggerFor]="channelsMenu">
                  <div class="channel-button-content">
                    <mat-icon inline="true" class="channel-icon">desktop_mac</mat-icon>
                    <span>
                      {{ currentChannel?.name || 'FRONTEND.LOOP.ALL_CHANNELS' | translate }}
                    </span>
                    <mat-icon inline="true">arrow_drop_down</mat-icon>
                  </div>
                </button>
                <mat-menu #channelsMenu="matMenu">
                  <ng-container *ngFor="let channel of channels">
                    <button
                      mat-menu-item
                      [disabled]="currentChannel?.value === channel.value"
                      (click)="selectChannel(channel)"
                    >
                      {{ channel.name | translate }}
                    </button>
                  </ng-container>
                </mat-menu>
              </div>
            }
          }
        }
      </div>

      <div class="row col col-xs-12 col-lg-8">
        <ng-container *ngIf="postsData$ | async as postsData; else loading">
          <div
            style="width: 100%"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [scrollWindow]="true"
            [infiniteScrollThrottle]="50"
            (scrolled)="loadMore()"
          >
            <sales-common-loop-v2-post
              *ngFor="let post of postsData.posts"
              [post]="post"
              [currentUser]="user"
            ></sales-common-loop-v2-post>
          </div>
          <ng-container *ngIf="!postsData.loading; else loading">
            @if (postsData.posts?.length === 0) {
              <div class="stream-item">
                <uikit-empty-state iconName="announcement">
                  <div state-description>
                    {{ 'FRONTEND.LOOP.EMPTY' | translate }}
                  </div>
                </uikit-empty-state>
              </div>
            }
          </ng-container>
        </ng-container>
      </div>

      <div class="col-xs-0 col-lg-2"></div>
    </div>
  </ng-container>
  <ng-template #compactTemplate>
    <ng-container *ngIf="postsData$ | async as postsData; else loading">
      <div class="compact-card-container">
        <va-card>
          <div class="compact-card">
            <div class="card-title">
              <mat-icon>all_inclusive</mat-icon>
              <span>{{ 'FRONTEND.LOOP.RECENT_POSTS' | translate }}</span>
            </div>
            <sales-common-loop-v2-post
              *ngFor="let post of postsData.posts"
              [post]="post"
              [currentUser]="user"
              compact="true"
              (postClicked)="clickedPost($event)"
            ></sales-common-loop-v2-post>
            <ng-container *ngIf="!postsData.loading; else loadingCompact">
              @if (postsData.posts?.length === 0) {
                <div class="stream-item">
                  <uikit-empty-state iconName="announcement">
                    <div state-description>
                      {{ 'FRONTEND.LOOP.EMPTY' | translate }}
                    </div>
                  </uikit-empty-state>
                </div>
              }
            </ng-container>
          </div>
          <va-card-link-button
            [text]="{ key: 'FRONTEND.LOOP.VIEW_ALL_POSTS' }"
            navigationIconName="chevron_right"
            (click)="clickedViewAll()"
          ></va-card-link-button>
        </va-card>
      </div>
    </ng-container>
  </ng-template>
</ng-container>

<ng-template #loading>
  <div class="stream-item">
    <div class="stream-item-container stencil-shimmer"></div>
  </div>
</ng-template>

<ng-template #loadingCompact>
  <div class="compact-loading stencil-shimmer"></div>
  <div class="compact-loading stencil-shimmer"></div>
  <div class="compact-loading stencil-shimmer"></div>
</ng-template>
